import { Star } from 'lucide-react';
import { SubscriberCounter } from './SubscriberCounter';
import { testimonialImages } from '@/data/testimonials';
import { useTranslation } from 'react-i18next';

export const SocialProof = () => {
  const { t } = useTranslation();
  const testimonials = t('socialProof.testimonials', { returnObjects: true }) as Array<{
    quote: string;
    name: string;
    title: string;
  }>;

  return (
    <div className="max-w-6xl mx-auto mb-12">
      {/* Subscriber Counter */}
      <div className="text-center mb-8">
        <SubscriberCounter />
      </div>

      {/* Testimonials */}
      <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-6">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="p-4 rounded-xl bg-background/20 backdrop-blur-sm border border-newsletter-primary/10 hover:border-newsletter-primary/20 transition-all duration-300">
            <div className="flex items-center gap-1 mb-2">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-newsletter-accent text-newsletter-accent" />
              ))}
            </div>
            <p className="text-sm text-muted-foreground mb-3">
              "{testimonial.quote}"
            </p>
            <div className="flex items-center gap-2">
              <img 
                src={testimonialImages[index]}
                alt={testimonial.name}
                className="w-8 h-8 rounded-full object-cover"
              />
              <div>
                <p className="text-sm font-medium">{testimonial.name}</p>
                <p className="text-xs text-muted-foreground">{testimonial.title}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
